import {
  GET_SCHEDULED_VOLVO,
  GET_SCHEDULED_VOLVO_ERROR,
  GET_SCHEDULED_VOLVO_SUCCESS,
  SEND_COMMENT_SCHEDULED,
  SEND_COMMENT_SCHEDULED_ERROR,
  SEND_COMMENT_SCHEDULED_SUCCESS,
} from './Scheduled.actions';

const initialState = {
  data: [],
  loading: true,
  error: false,
  sendingComment: false,
  commentError: null,
};

/**
 * The Scheduled Volvo Reducer.
 */
const scheduledVolvoReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case GET_SCHEDULED_VOLVO: {
      return { ...state, loading: true, error: undefined }; // Set loading to true
    }
    case GET_SCHEDULED_VOLVO_ERROR: {
      return { ...state, loading: false, error: payload.error }; // Set error and loading to false
    }
    case GET_SCHEDULED_VOLVO_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: undefined,
        data: payload.data, // Save the data to the state
      };
    }
    case SEND_COMMENT_SCHEDULED:
      return { ...state, sendingComment: true, commentError: null };

    case SEND_COMMENT_SCHEDULED_ERROR:
      return { ...state, sendingComment: false, commentError: payload.error };

    case SEND_COMMENT_SCHEDULED_SUCCESS:
      return { ...state, sendingComment: false, commentError: null };

    default:
      return state;
  }
};

export default scheduledVolvoReducer;
